/**
 * Route for `multi-channel-influencer-campaign-roi-dashboard`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { MultiChannelInfluencerCampaignRoiDashboardPage } from "../features/multi-channel-influencer-campaign-roi-dashboard/MultiChannelInfluencerCampaignRoiDashboardPage";

export const multiChannelInfluencerCampaignRoiDashboardRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/multi-channel-influencer-campaign-roi-dashboard",
	component: MultiChannelInfluencerCampaignRoiDashboardPage,
});

export default multiChannelInfluencerCampaignRoiDashboardRoute;
